import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CustomRouteMobileViewsStateService } from '../../components/custom-route-mobile/services/custom-route-mobile-views-state.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SendCustomRouteForm } from './interfaces/more.interface';
import { NameFieldComponent } from "./components/name-field/name-field.component";
import { ExtraInfoFieldComponent } from "./components/extra-info-field/extra-info-field.component";
import { EmailFieldComponent } from './components/email-field/email-field.component';
import { TermsCheckFieldComponent } from './components/terms-check-field/terms-check-field.component';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { CustomRouteDesktopViewStateService } from '../../components/custom-route-desktop/services/custom-route-desktop-view-state.service';
import { CUSTOM_ROUTE_DESKTOP_MAP } from '../../components/custom-route-desktop/config/constants';
import { ScrollService } from 'src/app/services/scroll.service';
import { SendRouteEmailService } from './services/send-route-email.service';
import { HttpErrorResponse } from '@angular/common/http';
import { openCiSnackbar } from '@iurban-malaga/cicerone-ui';


@Component({
  selector: 'app-more',
  standalone: true,
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    NameFieldComponent,
    EmailFieldComponent,
    ExtraInfoFieldComponent,
    TermsCheckFieldComponent,
],
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MoreComponent {
  private _translateService = inject(TranslateService);
  private _customRouteMobileViewsState = inject(CustomRouteMobileViewsStateService);
  private _customRouteDesktopViewStateService = inject(CustomRouteDesktopViewStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _breakpointsService = inject(BreakpointsService);
  private _fb = inject(FormBuilder);
  private _scrollService = inject(ScrollService);
  private _sendRouteEmailService = inject(SendRouteEmailService);
  
  private readonly _mobileViewsState = () => this._customRouteMobileViewsState.mobileViewsState();

  public isDesktopView = !this._breakpointsService.isMobile()
  
  public form: FormGroup<SendCustomRouteForm> = this._fb.group<SendCustomRouteForm>(
    {
      name: new FormControl<string>(null),
      email: new FormControl<string>(null, [
        Validators.required, 
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
      ]),
      extraInfo: new FormControl<string | null>(null),
      terms: new FormControl<boolean>(false, Validators.requiredTrue),
    }
  )
  
  ngOnInit(): void {
    this._sessionStorageService.setItem('customRouteMobileViewsState', this._mobileViewsState());
    
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.setIsScrolled(false);
  }

  public handleSubmit() {
    if (this.form.valid) {
      const formValues = this.form.value as unknown as SendCustomRouteForm;
      console.log('Form submitted:', formValues);
      
      this._sendRouteEmailService.sendRouteByEmail(formValues)
        .subscribe({
          next: (response) => { // TODO: TYPE
            console.log('Route sent successfully:', response);
            this._openSuccessSendCustomRouteByEmailSnackbar();
            
            // backend sends a prop 'msg' in case of error
            if (response.msg) {
              this._openErrorSendCustomRouteByEmailSnackbar();
            }
            
            this._redirectToMapPlannerView();
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error sending route:', error);
            this._openErrorSendCustomRouteByEmailSnackbar();
          },
        })

    } else {
      console.warn('Form is invalid');
    }
  }
  
  private _openSuccessSendCustomRouteByEmailSnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('Ruta enviada con éxito'),
      status: 'success',
      'icon-name': 'btn-check',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: 4000
    })
  } 
  
  private _openErrorSendCustomRouteByEmailSnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('Error al enviar la ruta'),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: 4000
    })
  } 
  
  private _redirectToMapPlannerView() {
    this._customRouteDesktopViewStateService.setDesktopViewsState(CUSTOM_ROUTE_DESKTOP_MAP.map);
    this._customRouteMobileViewsState.setMobileViewsState(CUSTOM_ROUTE_DESKTOP_MAP.map);
  }
  
  public handleCancel() {
    this._customRouteDesktopViewStateService.setDesktopViewsState(CUSTOM_ROUTE_DESKTOP_MAP.map);
  }
}
